import { orders as cacheSelectorsOrders } from '../selectors/ordersCache';
import { _, createSelector } from '../third-party';
import { APIOrder, APIUserType } from '../types/api';
import {
  hideOrderSensitiveFields,
  orderHasSensitiveData,
} from '../utils/sensitiveData';

export const createOrdersRefList = (
  orders: APIOrder[],
  pickKeys: (keyof APIOrder)[] = ['id'],
) => {
  return (orders || []).map((order) => _.pick(order, pickKeys));
};
export const createOrdersRefSelector = (
  ordersSelector: (state: any) => Partial<APIOrder>[],
  userTypeSelector: (state: any) => APIUserType | undefined,
) =>
  createSelector(
    [ordersSelector, userTypeSelector, cacheSelectorsOrders],
    (orders, userType, ordersCache) => {
      return orders.map((order) => {
        const orderFullData = {
          ...ordersCache.find((it) => order.id === it.id)!,
          ...order,
        };
        return orderHasSensitiveData(orderFullData, userType)
          ? hideOrderSensitiveFields(orderFullData)
          : orderFullData;
      });
    },
  );
